/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-factory.js to modify the generation of this file.
import { ComponentBuilder } from "@sitecore-jss/sitecore-jss-react";
import SampleComponent from "../renderings/SampleComponent";
import { Accordion } from "react-sitecore-library";
import { AgencySearch } from "react-sitecore-library";
import { AlertNotification } from "react-sitecore-library";
import { BackgroundCard } from "react-sitecore-library";
import { BlogCardList } from "react-sitecore-library";
import { BlogHero } from "react-sitecore-library";
import { BlogList } from "react-sitecore-library";
import { BlogListByCategory } from "react-sitecore-library";
import { BlogPinPost } from "react-sitecore-library";
import { BlogSideBar } from "react-sitecore-library";
import { Breadcrumb } from "react-sitecore-library";
import { CCPAForm } from "react-sitecore-library";
import { CalculatorAccordion } from "react-sitecore-library";
import { CalculatorCard } from "react-sitecore-library";
import { CallOutCard } from "react-sitecore-library";
import { CardLinkList } from "react-sitecore-library";
import { CardList } from "react-sitecore-library";
import { ColumnSubLayout } from "react-sitecore-library";
import { ConditionalNav } from "react-sitecore-library";
import { ContactCard } from "react-sitecore-library";
import { ContactModalList } from "react-sitecore-library";
import { FeaturedStats } from "react-sitecore-library";
import { FinProSearch } from "react-sitecore-library";
import { FinProSimpleSearch } from "react-sitecore-library";
import { FinproAgencyProfile } from "react-sitecore-library";
import { FinproAgentProfile } from "react-sitecore-library";
import { FinproStateDisplay } from "react-sitecore-library";
import { Hero } from "react-sitecore-library";
import { HorizontalCard } from "react-sitecore-library";
import { HorizontalLineCard } from "react-sitecore-library";
import { HorizontalTimeline } from "react-sitecore-library";
import { JssForm } from "react-sitecore-library";
import { LoginCard } from "react-sitecore-library";
import { MediaCard } from "react-sitecore-library";
import { MediaColumn } from "react-sitecore-library";
import { MediaHorizontalCard } from "react-sitecore-library";
import { ModalWindow } from "react-sitecore-library";
import { PressReleaseFilter } from "react-sitecore-library";
import { PressReleaseList } from "react-sitecore-library";
import { Rates } from "react-sitecore-library";
import { ScrollSpyNav } from "react-sitecore-library";
import { StyledHeading } from "react-sitecore-library";
import { TabNav } from "react-sitecore-library";
import { TabNavHorizontal } from "react-sitecore-library";
import { TabNavVertical } from "react-sitecore-library";
import { TitleTaglineDisplay } from "react-sitecore-library";
import { VerticalCard } from "react-sitecore-library";
import { VerticalTimeline } from "react-sitecore-library";
import { VideoPlayer } from "react-sitecore-library";

const components = new Map();
components.set("SampleComponent", SampleComponent);
components.set("Accordion", Accordion);
components.set("AgencySearch", AgencySearch);
components.set("AlertNotification", AlertNotification);
components.set("BackgroundCard", BackgroundCard);
components.set("BlogCardList", BlogCardList);
components.set("BlogHero", BlogHero);
components.set("BlogList", BlogList);
components.set("BlogListByCategory", BlogListByCategory);
components.set("BlogPinPost", BlogPinPost);
components.set("BlogSideBar", BlogSideBar);
components.set("Breadcrumb", Breadcrumb);
components.set("CCPAForm", CCPAForm);
components.set("CalculatorAccordion", CalculatorAccordion);
components.set("CalculatorCard", CalculatorCard);
components.set("CallOutCard", CallOutCard);
components.set("CardLinkList", CardLinkList);
components.set("CardList", CardList);
components.set("ColumnSubLayout", ColumnSubLayout);
components.set("ConditionalNav", ConditionalNav);
components.set("ContactCard", ContactCard);
components.set("ContactModalList", ContactModalList);
components.set("FeaturedStats", FeaturedStats);
components.set("FinProSearch", FinProSearch);
components.set("FinProSimpleSearch", FinProSimpleSearch);
components.set("FinproAgencyProfile", FinproAgencyProfile);
components.set("FinproAgentProfile", FinproAgentProfile);
components.set("FinproStateDisplay", FinproStateDisplay);
components.set("Hero", Hero);
components.set("HorizontalCard", HorizontalCard);
components.set("HorizontalLineCard", HorizontalLineCard);
components.set("HorizontalTimeline", HorizontalTimeline);
components.set("JssForm", JssForm);
components.set("LoginCard", LoginCard);
components.set("MediaCard", MediaCard);
components.set("MediaColumn", MediaColumn);
components.set("MediaHorizontalCard", MediaHorizontalCard);
components.set("ModalWindow", ModalWindow);
components.set("PressReleaseFilter", PressReleaseFilter);
components.set("PressReleaseList", PressReleaseList);
components.set("Rates", Rates);
components.set("ScrollSpyNav", ScrollSpyNav);
components.set("StyledHeading", StyledHeading);
components.set("TabNav", TabNav);
components.set("TabNavHorizontal", TabNavHorizontal);
components.set("TabNavVertical", TabNavVertical);
components.set("TitleTaglineDisplay", TitleTaglineDisplay);
components.set("VerticalCard", VerticalCard);
components.set("VerticalTimeline", VerticalTimeline);
components.set("VideoPlayer", VideoPlayer);

const componentBuilder = new ComponentBuilder({ components });

export const componentFactory = componentBuilder.getComponentFactory();
